import React, { useEffect, useState } from 'react';
import './ButtonToggle.scss';
import { appToggleSize } from '@utils/globalConstant';
import PropTypes from 'prop-types';

export function ButtonToggle({
  id = '',
  toggleSize = appToggleSize.DEFAULT,
  leftLabel = '',
  rightLabel = '',
  value = false,
  onChange = () => {}
}) {
  // State
  const [isActive, setIsActive] = useState(value);

  // Hooks
  useEffect(() => {
    onChange(isActive);
  }, [isActive]);

  useEffect(() => {
    setIsActive(value);
  }, [value]);

  return (
    <div className="toggle-switch d-flex">
      {leftLabel && (
        <span className={`${toggleSize} text-primary align-content-center pe-3`}>{leftLabel}</span>
      )}

      <div className="toggle-switch-button">
        <button
          type="button"
          role="switch"
          className={`btn btn-toggle p-0 position-relative rounded  ${
            isActive ? 'active' : 'inactive'
          }`}
          onClick={() => setIsActive(!isActive)}
          aria-label={id}>
          <div
            className={`handle position-absolute rounded-circle ${
              (leftLabel || rightLabel) && 'btn-with-label'
            }`}
          />
        </button>
      </div>

      {rightLabel && (
        <span className={`${toggleSize} text-primary align-content-center ps-3`}>{rightLabel}</span>
      )}
    </div>
  );
}

ButtonToggle.propTypes = {
  id: PropTypes.string,
  toggleSize: PropTypes.string,
  leftLabel: PropTypes.string,
  rightLabel: PropTypes.string,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func
};

export default ButtonToggle;
